import { Chip as MantineChip, ChipProps } from '@mantine/core';

export type IChipProps = ChipProps;

/** @registry Design-layer pass-through over Mantine Chip; import this instead of @mantine/core Chip outside src/design. Extend here when Chip needs house behavior. Compound statics (Chip.Group) are preserved. */
export const Chip = MantineChip;
